import React from 'react';
import { PURCHASES_LOCKED_MESSAGE } from '../config/site';

const PurchasesLockedNotice = () => (
  <div className="purchases-locked-notice" role="status">
    <p>{PURCHASES_LOCKED_MESSAGE}</p>
  </div>
);

export default PurchasesLockedNotice;
